import { Module } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { ClientRoute, ClientPathName } from '@/modules/ta/client/client.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ClientRoute.CLIENTS}`,
      name: ClientPathName.CLIENTS,
      component: () => import(/* webpackChunkName: "clients-page" */ './pages/ClientsPage.vue'),
    },
    {
      path: `/${ClientRoute.CLIENTS}/new`,
      name: ClientPathName.CLIENTFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "client-form-page" */ './pages/ClientFormPage.vue'),
      props: true,
    },
    {
      path: `/${ClientRoute.CLIENTS}/:id/overview`,
      name: ClientPathName.CLIENTOVERVIEW,
      component: () =>
        import(/* webpackChunkName: "client-details-page" */ './pages/ClientDetailsPage.vue'),
      props: true,
    },
    {
      path: `/${ClientRoute.CLIENTS}/:id/tab/:tabName?`,
      name: ClientPathName.CLIENTFORM,
      component: () =>
        import(/* webpackChunkName: "client-form-page" */ './pages/ClientFormPage.vue'),
      props: true,
    },
    {
      path: `/${ClientRoute.CLIENTS}/:id`,
      redirect: (to) => `/${ClientRoute.CLIENTS}/${to.params.id}/tab/settings`,
    },
  ],
  Module.CLIENT
);
